const isFiniteNumber = (value) => typeof value === "number" && Number.isFinite(value)
const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value))

export function scrollPanStartTop({ cardTop, cardHeight, viewportHeight }) {
  if (![cardTop, cardHeight, viewportHeight].every(isFiniteNumber)) return 0
  if (cardHeight <= 0 || viewportHeight <= 0) return 0
  if (cardTop + cardHeight <= 0) return 0

  return Math.min(cardTop, viewportHeight)
}

export function scrollPanProgress({ startTop, cardTop, cardHeight }) {
  if (![startTop, cardTop, cardHeight].every(isFiniteNumber)) return 0
  if (cardHeight <= 0) return 0

  const travelDistance = startTop + cardHeight
  if (travelDistance <= 0) return 0

  return clamp((startTop - cardTop) / travelDistance, 0, 1)
}

export function scrollPanRebasedStartTop({ cardTop, cardHeight, viewportHeight, progress }) {
  if (![cardTop, cardHeight, viewportHeight, progress].every(isFiniteNumber)) {
    return scrollPanStartTop({ cardTop, cardHeight, viewportHeight })
  }
  if (cardHeight <= 0 || viewportHeight <= 0) return 0
  if (cardTop + cardHeight <= 0) return 0

  const boundedProgress = clamp(progress, 0, 0.99995)
  const rebasedStartTop = (cardTop + boundedProgress * cardHeight) / (1 - boundedProgress)

  if (!Number.isFinite(rebasedStartTop) || rebasedStartTop + cardHeight <= 0) {
    return scrollPanStartTop({ cardTop, cardHeight, viewportHeight })
  }

  return rebasedStartTop
}

export function scrollPanPositionValue(geometry) {
  return `${(scrollPanProgress(geometry) * 100).toFixed(2)}%`
}
